import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DocumentService } from 'app/exercise-program/services/document.service';

@Component({
  selector: 'remove-exercise-dialog',
  templateUrl: './remove-exercise-dialog.component.html',
  styleUrls: ['./remove-exercise-dialog.component.scss']
})
export class RemoveExerciseDialogComponent implements OnInit {
  progressBar = false;
  progress = 0;
  mode = 'indeterminate';
  removeError: boolean;
  removeFinished: boolean;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<RemoveExerciseDialogComponent>,
    private documentService: DocumentService
  ) { }

  ngOnInit() {
  }

  /**
   * Try to remove exercise from database
   */
  remove() {
    this.progressBar = true;
    this.mode = 'indeterminate';

    this.documentService.removeExercise(this.data).subscribe(() => {
      this.removeFinished = true;
      this.mode = 'determinate';
      this.progress = 100;
    }, err => {
      this.mode = 'determinate';
      this.removeError = true;
      this.progress = 0;
    });
  }

  close() {
    this.dialogRef.close(true);
  }

  cancel() {
    this.dialogRef.close();
  }

}
